import React from 'react';
import { detailsData } from './detailsData';
import TemplateCard from './TemplateCard';
import { auditPlanningTemplatesData } from './auditPlanningTemplatesData';

const StepDetail = ({ selectedCard, selectedStep, onBack }) => {
  const details = detailsData[selectedCard];
  const step = details.steps[selectedStep];

  let detailedTemplateCard = null;
  if (selectedCard === 'audit-planning') {
    const detailedTemplate = auditPlanningTemplatesData[step.title];
    if (detailedTemplate) {
      detailedTemplateCard = <TemplateCard templateData={detailedTemplate} />;
    }
  }

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <button onClick={onBack} className="mb-4 text-blue-600">
        &larr; Back
      </button>
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        {details.title} - {step.title}
      </h2>
      <div className="bg-white border border-gray-200 rounded-lg shadow p-6">
        <p className="text-gray-700 mb-4">{step.content}</p>
        <div className="bg-gray-100 p-4 rounded mb-4">
          <h4 className="font-semibold mb-2">Sample Template:</h4>
          <p className="text-gray-600">{step.template}</p>
        </div>
        {step.documentUrl && (
          <a
            href={step.documentUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 text-white px-4 py-2 rounded"
          >
            Download Template
          </a>
        )}
      </div>
      {detailedTemplateCard}
    </div>
  );
};

export default StepDetail;
